module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('approval-remarks', {
    attrs: {
      "row-data": _vm.actionData,
      "steps": _vm.actionData.steps,
      "legal-step": 3
    }
  }), _vm._v(" "), (_vm.legalApproved) ? _c('div', [(_vm.isTowerCo()) ? _c('section', [_c('el-form', {
    attrs: {
      "label-position": "top",
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Approval"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select",
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        return _vm.approval()
      }
    },
    model: {
      value: (_vm.step.approvedStatus),
      callback: function($$v) {
        _vm.$set(_vm.step, "approvedStatus", $$v)
      },
      expression: "step.approvedStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Pending",
      "value": "Pending"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Rejected",
      "value": "Rejected"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Conditional",
      "value": "Conditional"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Approved",
      "value": "Approved"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.isPending) ? _c('el-form-item', {
    attrs: {
      "label": "Date"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.dateFormat,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.approved_at),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_at", $$v)
      },
      expression: "step.approved_at"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isPending) ? _c('el-form-item', {
    attrs: {
      "label": "Approval Remarks"
    }
  }, [_c('div', {
    staticClass: "html-remarks"
  }, [((_vm.isApprover() && _vm.canAccess('project'))) ? _c('html-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (!_vm.disabled && !_vm.isPending) ? _c('el-form-item', {
    staticStyle: {
      "padding-top": "3em"
    }
  }, [_c('el-button', {
    attrs: {
      "type": _vm.approvalButton,
      "icon": "fa fa-check",
      "disabled": (_vm.disabled || !_vm.step.approvedStatus || _vm.step.approvedStatus === 'Pending')
    },
    on: {
      "click": function($event) {
        return _vm.sendApproval()
      }
    }
  }, [_vm._v("\n          Send " + _vm._s(_vm.step.approvedStatus) + " e-Mail\n        ")])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Deposit Returned"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step5.depositReturned),
      callback: function($$v) {
        _vm.$set(_vm.step5, "depositReturned", $$v)
      },
      expression: "step5.depositReturned"
    }
  })], 1), _vm._v(" "), (_vm.step5.depositReturned) ? _c('el-form-item', {
    attrs: {
      "label": "Amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.disabled || !_vm.step5.depositReturned
    },
    model: {
      value: (_vm.step5.amount),
      callback: function($$v) {
        _vm.$set(_vm.step5, "amount", $$v)
      },
      expression: "step5.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.currencyLabel))])], 2)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.step5.deposit > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Deposit Returned"
    }
  }, [_c('strong', {
    domProps: {
      "textContent": _vm._s(this.formatMoney(_vm.step5.deposit, 0))
    }
  })]) : _vm._e(), _vm._v(" "), (!(_vm.step5.approved && (_vm.step.approvedStatus === 'Approved' || _vm.step.approvedStatus === 'Pending'))) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Re-submission Remarks"
    }
  }, [_c('div', {
    staticClass: "html-remarks"
  }, [(_vm.step5.resubmitRemarks) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.step5.resubmitRemarks)
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No remarks")])])])], 1) : _vm._e()], 1)], 1) : _c('section', [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "132px"
    }
  }, [(_vm.step5p1) ? _c('el-form-item', {
    attrs: {
      "label": "Approval Status"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.step5p1.approvedStatus ? _vm.step5p1.approvedStatus : 'Pending') + "\n             \n            "), (!_vm.step5p1.approved) ? _c('span', [_vm._v("Approval")]) : _vm._e(), _vm._v("\n             \n            "), (_vm.step5p1.approved) ? _c('i', {
    staticClass: "fa fa-check-circle text-success"
  }) : _vm._e(), _vm._v(" "), (_vm.step5p1.approvedStatus === 'Conditional') ? _c('i', {
    staticClass: "fa fa-question-circle text-warning"
  }) : _vm._e(), _vm._v(" "), (_vm.step5p1.approvedStatus === 'Rejected') ? _c('i', {
    staticClass: "fa fa-exclamation-circle text-danger"
  }) : _vm._e(), _vm._v(" "), (!_vm.step5p1.approved && (_vm.step5p1.approvedStatus !== 'Rejected' && _vm.step5p1.approvedStatus !== 'Conditional')) ? _c('i', {
    staticClass: "fa fa-info-circle text-muted"
  }) : _vm._e(), _vm._v("\n             ")]), _vm._v(" "), (_vm.step5p1.approved && _vm.step5p1.approvedStatus === 'Approved') ? _c('i', [_vm._v(_vm._s(_vm.formatFriendlyDate(_vm.step5p1.approved_at)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step5p1 && _vm.step5p1.remarks) ? _c('el-form-item', {
    attrs: {
      "label": "Approval Remarks"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "41.7vw",
      "overflow": "auto"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.step5p1.remarks)
    }
  })])]) : _vm._e(), _vm._v(" "), (!(_vm.step5p1 && _vm.step5p1.approved && (_vm.step5p1.approvedStatus === 'Pending' || _vm.step5p1.approvedStatus === 'Approved'))) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "Re-submission Remarks"
    }
  }, [(_vm.isTelco()) ? _c('div', [_c('html-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.step5.resubmitRemarks),
      callback: function($$v) {
        _vm.$set(_vm.step5, "resubmitRemarks", $$v)
      },
      expression: "step5.resubmitRemarks"
    }
  })], 1) : _c('div', {
    staticStyle: {
      "width": "41.7vw",
      "overflow": "auto",
      "text-align": "left"
    }
  }, [(_vm.step5.resubmitRemarks) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.step5.resubmitRemarks)
    }
  }) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No remarks")])])])], 1) : _vm._e()], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d5f27f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/requests/workflow/step5.vue
// module id = 1427
// module chunks = 0